import React from "react";

import {
    useNavigate
} from "react-router-dom";

import {
    useCart
} from "../context/CartContext";


export default function MarketplaceCart() {

    const navigate =
        useNavigate();

    const {
        items,
        subtotal,
        itemCount,
        updateQuantity,
        removeFromCart
    } = useCart();


    if (!items.length) {

        return (

            <div
                style={{
                    background: "#fff",
                    borderRadius: 18,
                    padding: 60,
                    textAlign: "center"
                }}
            >

                <h1>
                    Your Cart
                </h1>

                <p
                    style={{
                        color: "#64748b"
                    }}
                >
                    Your cart is currently empty.
                </p>

                <button
                    onClick={() =>
                        navigate(
                            "/brand/marketplace"
                        )
                    }
                    style={{
                        marginTop: 15,
                        padding:
                            "12px 24px",
                        border: "none",
                        borderRadius: 9,
                        background:
                            "#2563eb",
                        color: "#fff",
                        cursor: "pointer",
                        fontWeight: 600
                    }}
                >
                    Continue Shopping
                </button>

            </div>

        );

    }


    return (

        <div
            style={{
                maxWidth: 1100,
                margin: "0 auto",
                paddingBottom: 50
            }}
        >

            <h1>
                Your Cart
            </h1>


            <p
                style={{
                    color: "#64748b"
                }}
            >
                {itemCount} item
                {itemCount !== 1
                    ? "s"
                    : ""}
            </p>


            <div
                style={{
                    display: "grid",
                    gridTemplateColumns:
                        "minmax(0,1fr) 320px",
                    gap: 25,
                    alignItems:
                        "start"
                }}
            >

                {/* ITEMS */}

                <div
                    style={{
                        display:
                            "grid",
                        gap: 15
                    }}
                >

                    {items.map(
                        item => (

                            <div
                                key={
                                    item.cartKey
                                }
                                style={{
                                    background:
                                        "#fff",
                                    borderRadius:
                                        15,
                                    padding:
                                        18,
                                    display:
                                        "flex",
                                    gap:
                                        18,
                                    alignItems:
                                        "center"
                                }}
                            >

                                <div
                                    style={{
                                        width: 90,
                                        height: 90,
                                        borderRadius:
                                            10,
                                        background:
                                            "#f1f5f9",
                                        overflow:
                                            "hidden",
                                        flexShrink:
                                            0
                                    }}
                                >

                                    {item.image && (

                                        <img
                                            src={
                                                item.image
                                            }
                                            alt=""
                                            style={{
                                                width:
                                                    "100%",
                                                height:
                                                    "100%",
                                                objectFit:
                                                    "cover"
                                            }}
                                        />

                                    )}

                                </div>


                                <div
                                    style={{
                                        flex: 1
                                    }}
                                >

                                    <h3
                                        style={{
                                            margin:
                                                0
                                        }}
                                    >
                                        {
                                            item.title
                                        }
                                    </h3>


                                    {item.variant && (

                                        <div
                                            style={{
                                                marginTop:
                                                    5,
                                                color:
                                                    "#64748b",
                                                fontSize:
                                                    13
                                            }}
                                        >
                                            {
                                                item.variant.title
                                            }
                                        </div>

                                    )}


                                    <div
                                        style={{
                                            marginTop:
                                                8,
                                            fontWeight:
                                                600
                                        }}
                                    >
                                        {item.currency}
                                        {" "}
                                        {Number(
                                            item.unitPrice
                                        ).toFixed(2)}
                                    </div>

                                </div>


                                <input
                                    type="number"
                                    min="1"
                                    value={
                                        item.quantity
                                    }
                                    onChange={
                                        e =>
                                            updateQuantity(
                                                item.cartKey,
                                                e.target.value
                                            )
                                    }
                                    style={{
                                        width:
                                            65,
                                        padding:
                                            9,
                                        border:
                                            "1px solid #ddd",
                                        borderRadius:
                                            8
                                    }}
                                />


                                <button
                                    onClick={() =>
                                        removeFromCart(
                                            item.cartKey
                                        )
                                    }
                                    style={{
                                        border:
                                            "none",
                                        background:
                                            "#fee2e2",
                                        color:
                                            "#991b1b",
                                        borderRadius:
                                            8,
                                        padding:
                                            "9px 12px",
                                        cursor:
                                            "pointer"
                                    }}
                                >
                                    Remove
                                </button>

                            </div>

                        )
                    )}

                </div>


                {/* SUMMARY */}

                <div
                    style={{
                        background:
                            "#fff",
                        borderRadius:
                            18,
                        padding:
                            25,
                        position:
                            "sticky",
                        top: 20
                    }}
                >

                    <h2>
                        Summary
                    </h2>


                    <div
                        style={{
                            display:
                                "flex",
                            justifyContent:
                                "space-between",
                            marginTop:
                                20
                        }}
                    >

                        <span>
                            Subtotal
                        </span>

                        <strong>
                            ?
                            {Number(
                                subtotal
                            ).toFixed(2)}
                        </strong>

                    </div>


                    <button
                        onClick={() =>
                            navigate(
                                "/brand/checkout"
                            )
                        }
                        style={{
                            width:
                                "100%",
                            marginTop:
                                25,
                            padding:
                                "14px",
                            border:
                                "none",
                            borderRadius:
                                10,
                            background:
                                "rgb(255,0,204)",
                            color:
                                "#fff",
                            cursor:
                                "pointer",
                            fontWeight:
                                700
                        }}
                    >
                        Proceed to Checkout
                    </button>


                    <button
                        onClick={() =>
                            navigate(
                                "/brand/marketplace"
                            )
                        }
                        style={{
                            width:
                                "100%",
                            marginTop:
                                10,
                            padding:
                                "12px",
                            border:
                                "1px solid #ddd",
                            borderRadius:
                                10,
                            background:
                                "#fff",
                            cursor:
                                "pointer",
                            fontWeight:
                                600
                        }}
                    >
                        Continue Shopping
                    </button>

                </div>

            </div>

        </div>

    );

}